import { CaseAttributeDeleteRequest, CaseAttributesAddDto, CaseAttributesResponseDto } from "interfaces/Mueller.Business.Models";
import { Ref } from "react";
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT, WebApiRequest } from "tools/webservice";

export const getCaseAttributes = (controlNumber: string, mountedRef: Ref<boolean>, successCallback?: (response: CaseAttributesResponseDto[]) => void, errorCallback?: (error: any) => void) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/case-attributes/case/${controlNumber}`,
  successCallback,
  errorCallback,
  mountedRef
});

export const getLimitedCaseAttributes = (controlNumber: string, mountedRef: Ref<boolean>, successCallback?: (response: CaseAttributesResponseDto[]) => void, errorCallback?: (error: any) => void) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/case-attributes/limited/case/${controlNumber}`,
  successCallback,
  errorCallback,
  mountedRef
});

export const addCaseAttribute = (payload: CaseAttributesAddDto, mountedRef: Ref<boolean>, successCallback?: (response: any) => void, errorCallback?: (error: any) => void) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/case-attributes`,
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const editCaseAttribute = (caseAttributeId: number, payload: CaseAttributesAddDto, mountedRef: Ref<boolean>, successCallback?: (response: any) => void, errorCallback?: (error: any) => void) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/case-attributes/${caseAttributeId}`,
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const deleteCaseAttribute = (caseAttributeId: number, mountedRef: Ref<boolean>, successCallback?: (response: any) => void, errorCallback?: (error: any) => void) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/case-attributes/${caseAttributeId}`,
  successCallback,
  errorCallback,
  mountedRef
});